import { errorMessage } from "@workspace/domain/src/utils";
import { PERMISSIONS } from "@workspace/domain/src/utils/permissions";
import * as z from "zod";

const SortBy = ["name", "numberOfPermissions", "numberOfEmployees"] as const;
const SortOrder = ["asc", "desc"] as const;

const roleSchema = z.object({
  id: z.string(),

  agencyId: z.string(),
  name: z.string(),
  permissions: z.string().array(),
  numberOfEmployees: z.number(),
  numberOfPermissions: z.number(),

  createdAt: z.date(),
  updatedAt: z.date(),
});

const GetSchema = z.object({
  id: z.string(),
});

const BaseSchema = z.object({
  name: z
    .string(errorMessage("Name is required", "Name is invalid"))
    .nonempty("Name is required")
    .max(255, "Name must be less than 255 characters"),
  permissions: z.array(
    z.enum(PERMISSIONS),
    errorMessage("Permissions are required", "Permissions are invalid"),
  ),
});

const CreateSchema = BaseSchema;

const UpdateSchema = BaseSchema.extend({
  ...GetSchema.shape,
});

const DeleteSchema = GetSchema;

export const AdminRole = {
  Role: roleSchema,
  Get: GetSchema,
  Create: CreateSchema,
  Update: UpdateSchema,
  Delete: DeleteSchema,
  SortBy: SortBy,
  SortOrder: SortOrder,
};

export type AdminRole = {
  Role: z.infer<typeof roleSchema>;
  Get: z.infer<typeof GetSchema>;
  Create: z.infer<typeof CreateSchema>;
  Update: z.infer<typeof UpdateSchema>;
  Delete: z.infer<typeof DeleteSchema>;
  SortBy: (typeof SortBy)[number];
  SortOrder: (typeof SortOrder)[number];
};
